import { render, staticRenderFns } from "./BankTransactionForm.vue?vue&type=template&id=9796bfaa&"
import script from "./BankTransactionForm.vue?vue&type=script&lang=js&"
export * from "./BankTransactionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports